import httpClient, { downloadFile, uploadFileAndDownloadResponse, financeHttpClient } from '@/api/httpClient'
import { FLAG_DOUBTFUL_DEBT_REPORT } from '@/lib/utils/flags'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import { useFlag } from '@unleash/proxy-client-vue'
import { mapActions, mapGetters } from 'vuex'
import { map } from '../../lib'

export default {
  components: {
    FlexComponent,
  },
  setup() {
    const isDoubtfulDebtReportEnabled = useFlag(FLAG_DOUBTFUL_DEBT_REPORT)
    return {
      isDoubtfulDebtReportEnabled,
    }
  },
  computed: {
    ...mapGetters('payments', ['selectedPaymentDate', 'paymentsForTD', 'paymentDateRaw']),
    paymentPeriod() {
      const date = new Date(this.selectedPaymentDate)
      date.setMonth(date.getMonth() - 1)
      return date
    },
  },

  methods: {
    ...mapActions('payments', ['lockPaymentDate', 'downloadDoubtfulDebtReport']),
    async handleDownloadDoubtfulDebtReport() {
      try {
        await this.downloadDoubtfulDebtReport()
      } catch (error) {
        console.error('Failed to download doubtful debt report:', error)
        alert('Failed to download doubtful debt report. Please try again.')
      }
    },
    async handleDownload(client, url, data = {}) {
      try {
        await downloadFile(client, url, data)
      } catch (error) {
        console.error('Download failed:', error)
        alert('Download failed. Please try again.')
      }
    },
    async handleSendStoreEmails() {
      try {
        await httpClient.post('/store-invoice-payments/send', new URLSearchParams({ date: this.selectedPaymentDate }))
        alert('Store emails sent successfully.')
      } catch (error) {
        console.error('Failed to send store emails:', error)
        alert('Failed to send store emails. Please try again.')
      }
    },
    async handleUpload(url, refName) {
      const fileInput = this.$refs[refName]
      if (!fileInput?.files?.length) {
        alert('Please select a file first.')
        return
      }
      const formData = new FormData()
      formData.append('file', fileInput.files[0])
      try {
        await uploadFileAndDownloadResponse(httpClient, url, formData)
        fileInput.value = ''
      } catch (error) {
        console.error('Upload failed:', error)
        alert('Upload failed. Please try again.')
      }
    },
  },

  render() {
    return (
      <div class="page">
        <h2>Payments for date: {this.selectedPaymentDate}</h2>
        This flow is to create a payment. This should only be done centraly(Erik or Finance).
        <br />
        <div class="card" style={{ margin: 'auto', textAlign: 'center' }}>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(httpClient, '/v2/payments/getPaymentInvoices', {
                payment_period: this.paymentPeriod.getFullYear() + '-' + String(this.paymentPeriod.getMonth() + 1).padStart(2, '0'),
              })
            }
          >
            <span>Download invoices</span>
          </button>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(httpClient, '/customReports/getInvoiceJournal', {
                year: this.paymentPeriod.getFullYear(),
                month: String(this.paymentPeriod.getMonth() + 1),
              })
            }
          >
            <span>Get invoice journal</span>
          </button>
          <button type="button" class="summary-button-custom" onClick={() => this.handleSendStoreEmails()}>
            <span>Send store emails</span>
          </button>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(httpClient, '/paymentsInvoice/summary', {
                paymentDate: this.selectedPaymentDate,
              })
            }
          >
            <span>Summary</span>
          </button>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(httpClient, '/payments/TD/getPaymentBreakdown', {
                paymentDate: this.selectedPaymentDate,
              })
            }
          >
            <span>TD breakdown</span>
          </button>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(httpClient, '/calculateReturns', {
                paymentDate: this.selectedPaymentDate,
              })
            }
          >
            <span>Returns</span>
          </button>
          <button type="button" class="summary-button-custom" onClick={() => this.handleDownload(httpClient, '/customReports/cpaReserve')}>
            <span>Cpa reserve</span>
          </button>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(financeHttpClient, '/tax-return-export', {
                period: this.paymentPeriod.toISOString(),
              })
            }
          >
            <span>Swedish tax return</span>
          </button>
          {this.isDoubtfulDebtReportEnabled && (
            <button type="button" class="summary-button-custom" onClick={this.handleDownloadDoubtfulDebtReport}>
              <span>Download doubtful debt report</span>
            </button>
          )}
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(httpClient, '/customReports/storeProviders', {
                paymentDate: this.selectedPaymentDate,
              })
            }
          >
            <span>Store providers</span>
          </button>
          <a href="#" onclick="return false;">
            <button
              disabled={this.paymentDateRaw.locked == 1}
              onClick={() =>
                this.lockPaymentDate({
                  date: this.selectedPaymentDate,
                })
              }
            >
              Lock Payment Date
            </button>
          </a>
          Step 0(Work day 1): email all market to remind them to accept payments.
          <br />
          Step 1(Work day 1-2): all market should accept payments.
          <br />
          Step 2(Work day 3): Erik check so all have accepted all and do manual fixes that market have requested
          <br />
          Step 3: Email Anna-Karin that it is done
          <br />
          Step 4: Run command "php artisan TD:UpdatePaymentInfo" and send the errors to each market
          <br />
          Step 5: Email SLS and ask them to upgrade to premium publishers
          <br />
          Step 6: Create one time payment in TD. Download following files and upload them to each adverticer in our reseller
          <br />
          <flex-component wrap="wrap" gap={8} class="no-margin">
            {map(this.paymentsForTD, (paymentsInvoice) => (
              <button
                type="button"
                class="button"
                onClick={() => this.handleDownload(httpClient, `/paymentInvoice/${paymentsInvoice.id}/getPaymentForTD`)}
              >
                <span>{paymentsInvoice.name}</span>
              </button>
            ))}
          </flex-component>
          Step 7: Generate invoice Program Management -&gt; find it -&gt; options -&gt; Finance -&gt; Create invoice. Set todays date to
          Invoice period end
          <br />
          Step 8: Email, Elvira och Linda that they should settle the invoices
          <br />
          Step 9(Payment day): Press{' '}
          <button type="button" class="summary-button-custom" onClick={() => this.handleDownload(httpClient, '/payments/getPayments')}>
            <span>here</span>
          </button>{' '}
          to generate self invoice PDFs
          <br />
          Step 10: Check so all payments are done and all pdf are created.
          <br />
          Step 11: Email invoice to influencers with command "php artisan user:emailInvoices --invoiceId=1383" Step 13: Set show_user=1 on
          payment. Step 12: Upload mapping of Ax invoice id to Metapic id:
          <div>
            Select Excel for matching(Ax invoice id, Metapic invoice id):
            <input type="file" ref="axIdMatchingFile" />
            <button type="button" onClick={() => this.handleUpload('/v2/payments/upload-ax-id-matching', 'axIdMatchingFile')}>
              Upload
            </button>
          </div>
          <div>
            Select Excel for marking paid(Ax invoice id):
            <input type="file" ref="markPaidFile" />
            <button type="button" onClick={() => this.handleUpload('/v2/payments/mark-invoices-as-paid', 'markPaidFile')}>
              Upload
            </button>
          </div>
          <button
            type="button"
            class="summary-button-custom"
            onClick={() =>
              this.handleDownload(financeHttpClient, '/payments/export', {
                payment_date: this.selectedPaymentDate,
              })
            }
          >
            Download successful payments (xls)
          </button>
        </div>
      </div>
    )
  },
}
